import { getFirestore, collection, addDoc, serverTimestamp, query, orderBy, getDocs, writeBatch } from "firebase/firestore";
import { initializeApp, getApps, getApp } from "firebase/app";
import firebaseConfig from "../../fb.json";

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
const db = getFirestore(app);

export type ActivityAction = "create" | "edit" | "delete" | "deploy" | "deploy_complete" | "translate" | "push_sent";

interface ActivityEntry {
  action: ActivityAction;
  contentType?: string;
  docId?: string;
  docTitle?: string;
  detail?: string;
  user: string;
  photoURL?: string;
}

export async function logActivity(project: string, entry: ActivityEntry) {
  try {
    await addDoc(collection(db, "content", project, "_activity"), {
      ...entry,
      timestamp: serverTimestamp(),
    });
  } catch (err) {
    console.error("[activity] Failed to log:", err);
  }
}

// ── Refund activity (global _refund_activity collection) ──

const MAX_REFUND_ACTIVITY = 500;

export async function logRefundActivity(entry: { action: string; uid: string; detail?: string }) {
  const col = collection(db, "_refund_activity");
  await addDoc(col, { ...entry, timestamp: serverTimestamp() });

  // Cap at 500 entries — delete oldest
  try {
    const snap = await getDocs(query(col, orderBy("timestamp", "asc")));
    const excess = snap.size - MAX_REFUND_ACTIVITY;
    if (excess > 0) {
      const toDelete = snap.docs.slice(0, excess);
      for (let i = 0; i < toDelete.length; i += 500) {
        const batch = writeBatch(db);
        toDelete.slice(i, i + 500).forEach((d) => batch.delete(d.ref));
        await batch.commit();
      }
    }
  } catch (err) {
    console.error("[activity] Failed to cap refund activity:", err);
  }
}
